import createAxiosInstance from "../util/axiosInstance";



const api = createAxiosInstance('/cuota');


const fetchCuotasPendientes = async (ci, fecha) => {
    console.log("En service de pendientes...",ci,fecha)
    const response = await api.get(`/pendientes/${ci}/${fecha}`);
    return response.data;
};


const fetchCuotasBySocio = (socioId) => {
    return api.get(`/socio/${socioId}`);
};

const updateCuota = (id, cuotaData) => {
    return api.put(`/${id}`, cuotaData);
};

const fetchCuotasByRecibo = (idRecibo) => {
    return api.get(`/recibo/${idRecibo}`);
};

const generarCuotas = async (fecha) => {
    try {
        const response = await api.post(`/generar/${fecha}`);
       // console.log("service de cuota reponse=",response)
        return response; // Devuelve la respuesta completa
    } catch (error) {
       // console.log("Error del servidor:", error.response?.data); // Verifica la estructura de error
        const errorMessage = error.response?.data?.message || 'Error desconocido desde el servidor';
        throw new Error(errorMessage); // Lanza un error con el mensaje específico
    }
};

const fetchAllCuotas = async () => {
    const response = await api.get('/');
    return response;
};
const updateCuotas = (idcodreg, cuotasData) => {
    return api.put(`/pagar/${idcodreg}`, {
        cuotas: cuotasData
    });
};

export default {
    fetchCuotasBySocio,
    updateCuota,
    fetchCuotasByRecibo,
    generarCuotas,
    fetchCuotasPendientes,
    fetchAllCuotas,
    updateCuotas // Agregar el nuevo método
};

